import UserCookie from 'vue-cookies'
import store from '../../store'

export default async function availableForProcedure ({ next }) {
    const isLoggedIn = UserCookie.get('loggedin')
    const isProvider = UserCookie.get('user_type') && UserCookie.get('user_type') === 'provider'
    const providerId = UserCookie.get('provider_id')
    if (!isLoggedIn && isProvider && providerId) {
        return next('/')
    }
    try {
        await store.dispatch('hasProcedureAccess')
        const canAccessProcedure = store.getters.hasProcedureAccessData && store.getters.hasProcedureAccessData.data
        if (canAccessProcedure) {
            return next()
        } else {
            return next('/')
        }
    } catch (error) {
        console.error('Error fetching MSU qualification list:', error)
        return next('/')
    }
}
